import React from 'react';
import { Center, Tooltip } from '@mantine/core';
import { useNavigate } from 'react-router-dom';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon';
import { useTranslationCapManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';
import { HoldingEventType } from '@dealstack/shared/lib/generated';

interface Props {
	type: HoldingEventType;
	size?: string;
	linkTo?: string;
}

export const EventIcon = ({ type, size, linkTo }: Props) => {
	const navigate = useNavigate();
	const tCapManage = useTranslationCapManage();

	const getIconVariant = () => {
		return type === HoldingEventType.ASSIGNMENT_OF_VOTING_RIGHTS ? 'letter-a' : 'letter-p';
	};

	const getTooltipLabel = () => {
		return type === HoldingEventType.ASSIGNMENT_OF_VOTING_RIGHTS
			? tCapManage('holdings.event.assigment')
			: tCapManage('holdings.event.pledge');
	};

	const handleClick = () => {
		if (linkTo) {
			navigate(linkTo, {
				state: {
					navigationSource: true,
				},
			});
		}
	};

	return (
		<Tooltip
			label={getTooltipLabel()}
			withinPortal={true}
			styles={(theme) => ({
				tooltip: {
					backgroundColor: theme.white,
					color: theme.colors.dark[9],
					border: `1px solid ${theme.colors.gray[2]}`,
					borderRadius: theme.radius.sm,
					boxShadow: theme.shadows.lg,
					fontSize: theme.fontSizes.md,
					fontWeight: 400,
					padding: `${theme.spacing.xs}px ${theme.spacing.sm}px`,
					zIndex: 100,
				},
			})}
		>
			<Center
				sx={(theme) => ({
					cursor: linkTo ? 'pointer' : 'default',
					'& svg': {
						transition: 'all 0.2s ease',
					},
					'&:hover svg rect': {
						stroke: theme.colors.blue[2],
					},
					'&:hover svg path': {
						fill: theme.colors.blue[6],
					},
				})}
				onClick={linkTo ? handleClick : undefined}
			>
				<Icon variant={getIconVariant()} size={size} />
			</Center>
		</Tooltip>
	);
};
